import type {
  InterventionsBatchEditPropertyKey,
  InterventionsBatchEditSelectProperties,
} from "./interventions-batch-edit.type";
import type { InterventionLite } from "@/entities/intervention";

import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useDisableBatchTransition } from "@/modules/batch-transition";
import { hideInterventionsBatchEditTemplateProperty } from "@/modules/interventions/interventions-batch-edit-template";

export const useInterventionsBatchEditProperties = (
  interventions: InterventionLite[]
) => {
  const { t } = useTranslation();

  const [currentProperty, setCurrentProperty] =
    useState<InterventionsBatchEditPropertyKey | null>(null);

  const stateDisabled = useDisableBatchTransition(
    "intervention",
    interventions
  );

  const properties: InterventionsBatchEditSelectProperties = [
    {
      value: "state",
      label: t("intervention:batchEdit.state.optionTitle"),
      ...stateDisabled,
    },
    {
      value: "template",
      label: t("intervention:batchEdit.template.optionTitle"),
      hidden: hideInterventionsBatchEditTemplateProperty(interventions),
    },
    {
      value: "scheduled_date",
      label: t("intervention:batchEdit.scheduledDate.optionTitle"),
    },
    {
      value: "users",
      label: t("intervention:batchEdit.users.optionTitle"),
    },
  ];

  return {
    properties,
    currentProperty,
    setCurrentProperty,
  };
};
